import { TrelloWindow } from '@trello/window-types';

import { getDefaultLocale } from './getDefaultLocale';
import { getSupportedLocales } from './getSupportedLocales';

declare const window: TrelloWindow;

function getCookie(name: string) {
  return document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split('=')?.[1];
}

export function getPreferredLocale() {
  const langOverride = getCookie('langOverride');

  if (langOverride && getSupportedLocales().includes(langOverride)) {
    return langOverride;
  }

  const token =
    getCookie('token') ?? getCookie('token2999') ?? getCookie('token3000');

  if (!token) {
    return getDefaultLocale();
  }

  const memberId = token.split('/')[0];
  // eslint-disable-next-line @trello/ban-identifiers
  const localeMemberPref = window.localStorage.getItem(`locale-${memberId}`);

  if (localeMemberPref && getSupportedLocales().includes(localeMemberPref)) {
    return localeMemberPref;
  }

  return getDefaultLocale();
}
